import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const GoogleTagManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Inicializa o dataLayer se não existir
    window.dataLayer = window.dataLayer || [];

    // Dispara o evento de visualização de página a cada mudança de rota
    // O GTM já está carregado via index.html, então apenas enviamos eventos
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

